const formatThenPrice = (price) => {
  if (!price.then2) {
    return (price.then1 || '').toString();
  }
  if (!price.then1) {
    return '';
  }
  return `${price.then1}, ${price.then2}`;
};

export const mapProduct = (product, index) => {
  const {
    id,
    productId,
    priceRange,
    price: priceValue = {
      currency: '',
      now: '',
      then1: '',
      then2: '',
      was: '',
    },
    outOfStock = '',
    colorSwatches = [],
    rating = {
      averageRating: '',
      reviews: '',
    },
    defaultSkuId,
    isMultiSku,
    adId,
    promoClassifications,
    isMerchBoost = false,
  } = product;

  const price = priceRange || priceValue;
  const { now: priceNow = '', was: priceWas = '' } = price;
  const priceThen = formatThenPrice(price);

  const listPosition = index > -1 ? index + 1 : undefined;
  const citrusAdId = adId || undefined;
  const promotionClassifications = promoClassifications?.length
    ? promoClassifications
    : undefined;

  return {
    currency: 'gbp',
    productId: id || productId,
    sku: defaultSkuId,
    isOutOfStock: outOfStock,
    numColourSwatches: colorSwatches?.length,
    numReviews: rating?.reviews,
    rating: rating?.averageRating,
    priceNow,
    priceThen,
    priceWas,
    isMultiSku,
    mb: isMerchBoost ? 1 : 0,
    ...(listPosition && { listPosition }),
    ...(citrusAdId && { citrusAdId }),
    ...(promotionClassifications && { promotionClassifications }),
  };
};
